import { IProzessEventsWithAdditionalData } from "../../../pages/funktion/funktion.types";
import { ILocalFerkelDto } from "../../../db/database";
import { ProzessType, Geschlecht } from "../../../api/backend-api-v7";

export const geschlechtProzessEventHandler = (
  ferkel: ILocalFerkelDto,
  prozessEvents: IProzessEventsWithAdditionalData[],
  next: (ferkel: ILocalFerkelDto, prozessEvents: IProzessEventsWithAdditionalData[]) => void
) => {
  const geschlecht = prozessEvents.find(pe => pe.prozessType === ProzessType.GESCHLECHT);

  if (geschlecht) {
    const updatedFerkel = { ...ferkel, geschlecht: geschlecht.data as Geschlecht };
    return next(updatedFerkel, prozessEvents);
  }
  return next(ferkel, prozessEvents);
};
